import { BetaTesterWarningIcon } from '@local/assets/icons'

import styles from './NoContentReview.module.scss'

const NoContentReview = () => {
  return (
    <div className={styles.wrapper}>
      <BetaTesterWarningIcon className={styles.icon} aria-hidden="true" />
      <div className={styles.tit_area}>작성자가 삭제하거나 유효하지 않은 리뷰입니다.</div>
    </div>
  )
}

export default NoContentReview
